<div
  [class]="{
    'device-card-editing': editingMode,
    'device-card-normal': !editingMode
  }"
  class="device-card"
  [attr.data-testid]="testIds.deviceCard">
  <!--
  @let isVerified = this.deviceService.isVerified(deviceId()) | async;-->
  <div class="device-card-header" [attr.data-testid]="testIds.deviceCardHeader">
    @if (isVerified) {
      <mat-icon class="check-circle" svgIcon="check-circle"></mat-icon>
    }
    @if (editingMode) {
      <input
        type="text"
        class="device-name-input"
        [(ngModel)]="tempDisplayName"
        id="name-input"
        [attr.data-testid]="testIds.deviceCardHeaderInput"
        maxlength="100" />
      <mat-icon class="pen" svgIcon="pen"></mat-icon>
    } @else {
      <span class="device-name" id="name-span" [attr.data-testid]="testIds.deviceCardHeaderName">
        {{ tempDisplayName }}
      </span>
    }
  </div>
  <div class="device-card-body" [attr.data-testid]="testIds.deviceCardBody1">
    <div class="device-attributes">
      <span>IP Adresse</span>
      <span>Device ID</span>
    </div>
    <div class="device-values">
      <span [attr.data-testid]="testIds.deviceCardBody1IpValue">{{ getLastSeenIp(lastSeenIp()) }}</span>
      <span [attr.data-testid]="testIds.deviceCardBody1DeviceIdValue" class="ellipsis" [matTooltip]="deviceId()">
        {{ deviceId() }}
      </span>
    </div>
  </div>
  <hr class="devider" [attr.data-testid]="testIds.dividerTitle" />
  <div class="device-card-body" [attr.data-testid]="testIds.deviceCardBody2">
    <div class="device-attributes">
      <span>Zeitstempel</span>
    </div>
    <div class="device-values">
      <span [attr.data-testid]="testIds.deviceCardBody2LastSeenValue">{{
        lastSeenDate | date: 'dd.MM.yyyy, HH:mm:ss'
      }}</span>
    </div>
  </div>
  <div class="device-card-buttons">
    <app-button
      (click)="deleteDevice()"
      onKeyUp="deleteDevice()"
      [isPrimary]="false"
      class="device-button"
      [dataTestId]="testIds.deviceCardButtonDelete"
      text="Abmelden"></app-button>
    @if (!editingMode) {
      <app-button
        text="Bearbeiten"
        [isPrimary]="true"
        (click)="startEditingMode()"
        onKeyUp="startEditingMode()"
        class="device-button"
        [dataTestId]="testIds.deviceCardButtonEdit"></app-button>
    } @else {
      <app-button
        text="Abbrechen"
        [isPrimary]="false"
        (click)="cancelChanges()"
        onKeyUp="cancelChanges()"
        class="device-button"
        [dataTestId]="testIds.deviceCardButtonCancel"></app-button>
      <app-button
        text="Speichern"
        [isPrimary]="true"
        (click)="saveChanges()"
        onKeyUp="saveChanges()"
        class="device-button"
        [dataTestId]="testIds.deviceCardButtonSave"></app-button>
    }
  </div>
</div>
